type BrandMarkProps = {
  invert?: boolean;
  compact?: boolean;
};

export function BrandMark({ invert = false, compact = false }: BrandMarkProps) {
  return (
    <span className={`brand-mark ${invert ? "brand-mark--invert" : ""} ${compact ? "brand-mark--compact" : ""}`}>
      S
    </span>
  );
}
